import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import html2pdf from "html2pdf.js";
import ReactAudioPlayer from "react-audio-player";
import UserSideMenu from "../../menu/UserSideMenu";
import Header from "../common/HeaderAfterLogin";
import { postServerDataWithPath } from "../../action/common_action";
import { ANY_ERROR } from "../../action/user_action_types";
import { domain, fileUrl, endPoints } from "../../config";
import { GetPdfHtml } from "../common/CampaignPdfHtml";
import { Editor, EditorState, convertToRaw } from "draft-js";
import { stateFromHTML } from "draft-js-import-html";
import draftToHtml from "draftjs-to-html";
import "draft-js/dist/Draft.css";
import Drag from "./dragNdDrop";
import PaymentModel from "./paymentModel";

import {
  getUserData,
  razorPayKey,
  calculateCutoffTime,
  axiosInstnace as axios,
  getMinimumStartDate,
  calculateAmountAndTax,
} from "../../util/util";
import RejectModel from "./rejectModel";
import ApproveModel from "./approveModel";
import AudioBriefPopup from "../admin/audioadminmanagment/AudioBriefPopup";
import { ChangeStartDate } from "./ChangeDate";
import { addDays, getDay } from "date-fns";
import { history } from "../../history/history";
import { toast, ToastContainer } from "react-toastify";
import { ShowStations } from "./ShowStations";

class ViewCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioFile: null,
      audioFiles: [],
      editor: "",
      editoreditstate: true,
      audioBrief: EditorState.createWithContent(
        stateFromHTML(props.campaign.audioBrief)
      ),
      uploadAudioBrief: null,
      uploadedAudioBrief: null,
      reply: ["Accept", "Reject"],
      audiostatus: undefined,
      isShowing: false,
      isRejectShowing: false,
      filesFields: {
        audioDuration: null,
        fctPerDay: null,
        totalPackageCost: null,
        amount: null,
        secondages: null,
        taxes: null,
        totalCost: null,
        packageDiscountedCost: null,
      },
      showPaymentModel: false,
      toggleAudioBrief: false,
      editAudioBrief: false,
      actualPendingAmount: null,
      audioDiscountStatus: false,
      paymentCutOffTime: null,
      changeStartDate: false,
      minStartDate: null,
      startDate: null,
      cutoffLimitCrossed: false,
      crossRefId: null,
      savedraft: false,
      showstationlist: false,
      currentStations: [],
    };
    let day = getMinimumStartDate();
    this.state.minStartDate = addDays(new Date(), day);
    this.state.campaign = calculateAmountAndTax(props.campaign, false);
    if (!props.campaign.audioBrief || props.campaign.audioBrief.trim() == "") {
      this.state.audioBrief = EditorState.createWithContent(
        stateFromHTML("Not Available")
      );
    }
    console.log(this.state.campaign, "CrossRef");
    if (
      this.state.campaign.totalPackageCost -
        this.state.campaign.packageDiscountedCost >=
        20000 ||
      this.state.campaign.audioDuration *
        this.state.campaign.rotationPerDay *
        this.state.campaign.days >=
        4000
    ) {
      this.state.actualPendingAmount =
        this.state.campaign.pendingAmount -
        (this.state.campaign.audioCost * 0.18 + this.state.campaign.audioCost);
    }
    if (
      this.state.campaign.status == "Audio Approved" &&
      this.state.actualPendingAmount
    )
      this.state.audioDiscountStatus = true;
    debugger;
    this.state.paymentCutOffTime = calculateCutoffTime(
      this.state.campaign.startDate
    ).format("MMMM Do YYYY, h:mm:ss a");
    //       let duration = moment.duration(moment().diff(moment(this.state.paymentCutOffTime)));
    //       this.state.audioDiscountTimer = {
    //         days: duration.asDays(),
    //         hours: duration.asHours(),
    //         minutes: duration.asMinutes(),
    //         seconds: duration.asSeconds()
    //       }
    // console.log(this.state.audioDiscountTimer)
  }

  setEditorState = (editor) => {
    this.setState({
      editor,
    });
    console.log(this.state.editor);
  };
  hideshowstations = (e) => {
    this.setState({ showstationlist: !this.state.showstationlist });
  };

  focusEditor = () => {
    if (this.state.editor) {
      this.state.editor.focus();
    }
  };
  HandleCrossRef = (evt) => {
    let current = this.props.campaigns.find((e) => {
      return e._id == evt.target.id;
    });
    this.setState({
      campaign: current,
    });
  };

  //Calculate total cost, secondages, amount etc after uploading the file
  calculateCost = (audioDuration) => {
    let { filesFields } = this.state;
    let { campaign } = this.props;
    let {
      rodp,
      rotationPerDay,
      days,
      additionalBenefits,
      couponDiscount,
    } = campaign;
    let secondages = rotationPerDay * audioDuration * days;
    let fctPerDay = rotationPerDay * audioDuration;
    let totalPackageCost = fctPerDay * (rodp / 10) * days;
    let packageDiscountedCost = Math.round(
      (Number(additionalBenefits) * totalPackageCost) / 100
    );
    let taxAmount = totalPackageCost - packageDiscountedCost;
    let taxes = Math.round((18 * taxAmount) / 100);
    let amount = totalPackageCost - (packageDiscountedCost + couponDiscount);
    let totalCost = Math.round(amount + taxes);
    this.setState({
      filesFields: {
        ...filesFields,
        secondages,
        fctPerDay,
        totalPackageCost,
        amount,
        packageDiscountedCost,
        totalCost,
        taxes,
      },
    });
  };

  //Calculate Audio duration
  calculateAudioDuration = (audioDuration) => {
    if (audioDuration > 10 && audioDuration < 15) {
      return 15;
    }
    if (audioDuration > 15 && audioDuration < 20) {
      return 20;
    }
    if (audioDuration > 20 && audioDuration < 25) {
      return 25;
    }
    if (audioDuration > 25 && audioDuration < 30) {
      return 30;
    } else {
      return 30;
    }
  };

  //Get audio duration
  getAudioDuration = (file) => {
    let { filesFields } = this.state;
    let { campaign } = this.props;
    var reader = new FileReader();
    reader.onload = () => {
      var audio = new Audio(reader.result);
      audio.onloadedmetadata = async () => {
        this.setState({
          filesFields: {
            ...filesFields,
            audioDuration: Math.floor(audio.duration),
          },
        });
      };
    };
    reader.readAsDataURL(file);
  };

  //Upload audio file
  handleUpload = (event) => {
    let { name, files } = event.target;
    this.setState(
      {
        [name]: files,
      },
      () => {
        this.getAudioDuration(files[0]);
      }
    );
  };

  audioRoundOff = (bytes, decimals = 2) => {
    console.log("calculation for audion length");
    var sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes == 0) return "0 bytes";
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed()) + " " + sizes[i];
  };

  getAudioBriefFile = (uploadedAudioBrief) => {
    console.log(uploadedAudioBrief.target.value);
    this.state.uploadedAudioBrief = uploadedAudioBrief.target.value;
  };

  updateAudioBrief = async () => {
    let { campaign } = this.props;
    if (!this.state.audioBrief) {
      return this.props.showError("Enter Audio Brief to proceed");
    }
    let data = {};

    if (campaign.audioBrief && campaign.audioBrief !== "") {
      if (campaign.audioUrl && campaign.audioUrl !== "") {
        data = {
          _id: campaign._id,
          updateObj: {
            audioBrief: this.state.audioBrief,
            audioStatus: "Requested",
          },
        };
      } else {
        alert("Cannot update audio brief during audio creation!");
      }
    } else {
      data = {
        _id: campaign._id,
        updateObj: {
          audioBrief: this.state.audioBrief,
        },
      };
    }

    // await this.props.updateCompainAudio(endPoints.updateCampaignAudio, formData, '/dashboard');
    const result = await axios.post(endPoints.updateCampaign, data);
    this.props.showError("Audio brief updated successfully");
    this.props.previousPage();
  };

  editAudioBrief = (audioBrief) => {
    console.log(audioBrief);
    this.state.audioBrief = audioBrief;
    this.state.editAudioBrief = true;
  };

  //Updating the campaign details
  updateCampaign = async () => {
    let { campaign } = this.props;
    let { audioFile, audioFiles, filesFields } = this.state;
    if (!audioFile && audioFiles.length == 0) {
      return this.props.showError("Please select a file!");
    }
    let formData = new FormData();
    formData.append("_id", campaign._id);
    formData.append(
      "fileName",
      audioFile && audioFile[0] ? audioFile[0].name : audioFiles[0].name
    );
    formData.append(
      "fileSize",
      audioFile && audioFile[0] ? audioFile[0].size : audioFiles[0].size
    );
    if (audioFile) {
      formData.append("file", audioFile[0]);
    }
    if (audioFiles.length > 0) {
      audioFiles.forEach((element, i) => {
        formData.append(`audio-${i}`, element);
      });
    }
    formData.append("audioStatus", "Uploaded");
    for (let key in filesFields) {
      if (filesFields[key]) {
        formData.append(key, filesFields[key]);
      }
    }
    if (parseInt(filesFields.audioDuration) > campaign.audioLength) {
      return this.props.showError(
        "Audio length should not be greater than " +
          campaign.audioLength +
          " Secs"
      );
    } else {
      await this.props.updateCompainAudio(
        endPoints.updateCampaignAudio,
        formData,
        "/dashboard"
      );
      this.props.previousPage();
    }
  };
  handleToastError = (error) => {
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,
      hideProgressBar: true,
      toastId: "1",
    });
  };
  handleStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  //Updating the payment status of campaign
  updateCampaignDetails = async (payId) => {
    let { campaign } = this.props;
    let updateCampaign = {
      _id: campaign._id,
      updateObj: {
        pendingAmount: 0,
        payId_1: payId,
        audioRefundAmount: Number(campaign.totalCost - campaign.pendingAmount),
        splitAmount1: Number(campaign.totalCost - campaign.pendingAmount),
        splitAmount2: Number(campaign.pendingAmount),
        status: campaign.status,
      },
      userEmail: campaign.userEmail,
    };
    if (this.state.cutoffLimitCrossed) {
      updateCampaign.updateObj.audioRefundAmount = "";
      updateCampaign.updateObj.startDate = this.state.startDate;
      updateCampaign.updateObj.status = "Pending";
    }
    if (!this.state.audioDiscountStatus) {
      updateCampaign.updateObj.audioRefundAmount = "";
    }
    if (!this.state.campaign.payId) {
      updateCampaign.updateObj = {
        payId,
      };
    }
    if (this.state.cutoffLimitCrossed) {
      updateCampaign.updateObj.startDate = this.state.startDate;
    }
    if (updateCampaign.updateObj.payId_1) {
      updateCampaign.updateObj.paymentdates = {
        payId_1: +new Date(),
      };
    } else if (updateCampaign.updateObj.payId) {
      updateCampaign.updateObj.paymentdates = {
        payId: +new Date(),
      };
    }
    console.log("Before to server");
    console.log(updateCampaign);
    if (
      updateCampaign.updateObj &&
      Object.keys(updateCampaign.updateObj).length === 0 &&
      updateCampaign.updateObj.constructor === Object
    ) {
      window.location.reload(true);
    } else if (updateCampaign.updateObj && updateCampaign.updateObj.payId) {
      await this.props.updateCompainAudio(
        endPoints.updateCampaign,
        updateCampaign,
        "/comapignsuccess"
      );
    } else {
      await this.props.updateCompainAudio(
        endPoints.updateCampaign,
        updateCampaign,
        "/dashboard"
      );
      this.props.previousPage();
    }
    this.props.previousPage();
  };
  checkTransactionTime = () => {
    if (
      moment() < moment(this.state.paymentCutOffTime, "MMMM Do YYYY, h:mm:ss a")
    ) {
      this.hidePaymentModel();
    } else {
      this.setState({
        changeStartDate: true,
        cutoffLimitCrossed: true,
      });
    }
  };
  startDateHandler = () => {
    this.setState({
      changeStartDate: !this.state.changeStartDate,
    });
  };

  hidePaymentModel = () => {
    let { showPaymentModel } = this.state;
    this.setState({
      showPaymentModel: !showPaymentModel,
      changeStartDate: false,
    });
  };

  submitTransactionDetails = async ({
    refno,
    accountno,
    ifsc,
    amount,
    paymentdate,
    savedraftValue,
  }) => {
    debugger;
    let { campaign } = this.props;
    let updateCampaign = {
      _id: campaign._id,
      updateObj: {
        pendingAmount: 0,
        audioRefundAmount: Number(campaign.totalCost - campaign.pendingAmount),
        splitAmount1: Number(campaign.totalCost - campaign.pendingAmount),
        splitAmount2: Number(campaign.pendingAmount),
        status: campaign.status,
      },
      userEmail: campaign.userEmail,
    };
    if (this.state.cutoffLimitCrossed) {
      updateCampaign.updateObj.audioRefundAmount = "";
      updateCampaign.updateObj.startDate = this.state.startDate;
      updateCampaign.updateObj.status = "Pending";
    }
    if (!this.state.audioDiscountStatus) {
      updateCampaign.updateObj.audioRefundAmount = "";
    }
    if (this.state.cutoffLimitCrossed) {
      updateCampaign.updateObj.startDate = this.state.startDate;
    }
    if (updateCampaign.updateObj.payId_1) {
      updateCampaign.updateObj.paymentdates = {
        payId_1: +new Date(),
      };
    } else if (updateCampaign.updateObj.payId) {
      updateCampaign.updateObj.paymentdates = {
        payId: +new Date(),
      };
    }
    let data = {
      refno,
      campaignId: this.state.campaign._id,
      campaignName: this.state.campaign.name,
      ifsc,
      account_number: accountno,
      paymentdate,
      savedraft: savedraftValue,
      amount,
      email:
        this.state.campaign && this.state.campaign.userDetails.length > 0
          ? this.state.campaign.userDetails[0].email
          : null,
      mobile:
        this.state.campaign && this.state.campaign.userDetails.length > 0
          ? this.state.campaign.userDetails[0].mobile
          : null,
    };
    debugger;
    let response = await axios.post(endPoints.updateOfflineTransaction, data);
    if (response && response.data.statusCode == 200) {
      this.setState({
        savedraft: false,
      });
      let result = response.data.data;
      debugger;
      if (
        updateCampaign.updateObj &&
        updateCampaign.updateObj.splitAmount1 &&
        !this.state.campaign.payId
      ) {
        await this.props.updateCompainAudio(
          endPoints.updateCampaign,
          updateCampaign,
          "/comapignsuccess"
        );
      } else {
        debugger;
        await this.props.updateCompainAudio(
          endPoints.updateCampaign,
          updateCampaign,
          "/dashboard"
        );
        window.location.reload(true);
      }
      // history.push("/comapignsuccess", { result });
    } else {
      if (
        response.data.message === "Please enter valid transaction Ref number"
      ) {
        this.setState({
          savedraft: true,
        });
      }
      this.handleToastError(response.data.message);
    }
  };

  //Make pending payment for campaign
  makePayment = () => {
    console.log(this.state.startDate);
    this.setState({
      showPaymentModel: false,
    });
    let { props } = this;
    let { campaign } = props;
    let userDetails =
      this.state.campaign && this.state.campaign.userDetails.length > 0
        ? this.state.campaign.userDetails[0]
        : null;
    var options = {
      key: razorPayKey,
      amount:
        !this.state.campaign.payId && this.state.campaign.bigFmAudio == "false"
          ? Number(this.state.campaign.totalCost) * 100
          : !this.state.campaign.payId &&
            this.state.campaign.bigFmAudio == "true"
          ? Number(
              this.state.campaign.audioCost +
                Math.floor(this.state.campaign.audioCost * 0.18)
            ) * 100
          : this.state.audioDiscountStatus &&
            moment() <
              moment(this.state.paymentCutOffTime, "MMMM Do YYYY, h:mm:ss a")
          ? Number(this.state.actualPendingAmount) * 100
          : Number(campaign.pendingAmount) * 100,
      name: "BigFm",
      description: "Purchase Description",
      image: "/assets/images/logo_blue.png",
      handler: async (response) => {
        const params = {
          payId: response.razorpay_payment_id,
          userEmail: userDetails.email,
          amount: Number(campaign.pendingAmount) * 100,
        };
        this.updateCampaignDetails(params.payId);
      },
      prefill: {
        name: userDetails.name,
        contact: userDetails.mobile,
        email: userDetails.email,
      },
      notes: {
        agencyId: "",
        campaignId: this.state.campaign._id,
        campaignName: this.state.campaign.name,
      },
      theme: {
        color: "#1f7cc0",
      },
    };
    var rzp1 = new Razorpay(options);
    rzp1.open();
  };

  //Generate the PDF for campaign
  generatePdf = async () => {
    let { campaign } = this.props;
    const input = document.getElementById("divToPrint");
    input.style.display = "block";
    var opt = {
      filename: `${this.state.campaign._id}.pdf`,
    };
    await html2pdf()
      .from(input)
      .set(opt)
      .save();
    input.style.display = "none";
  };

  styles = {
    editor: {
      width: "360%",
      height: "12em",
      overflow: "auto",
    },
  };

  toggle = () => {
    if (this.state.campaign.audioLength > this.state.campaign.audioDuration) {
      this.setState({
        custommsg: "Note! Uploaded Audio has less than the requested length.",
      });
    }
    this.setState({
      isShowing: !this.state.isShowing,
    });
  };

  rejectToggle = () => {
    this.setState({
      isRejectShowing: !this.state.isRejectShowing,
    });
  };
  getUploadedFile = (files) => {
    console.log("Audio File>>>", files);
    let sizes = files.map((e) => {
      return e.size;
    });
    sizes = [...new Set(Array.from(sizes))];
    if (sizes.length > 1) {
      alert("Please select the audios in same duration");
      return;
    }
    this.setState({ audioFiles: files });
    this.getAudioDuration(files[0]);
  };

  showHideAudioBrief = () => {
    this.setState({
      toggleAudioBrief: !this.state.toggleAudioBrief,
      // audioBrief: audioBrief,
    });
  };

  removeFileInCollection = (evt) => {
    this.setState({
      audioFiles: this.state.audioFiles.filter((e) => {
        return e.path !== evt;
      }),
    });
  };

  //Returning the html for campaign
  render() {
    let { props } = this;
    let { audioFile, audioBrief } = this.state;
    let { campaign } = props;
    let { isShowing, isRejectShowing, toggleAudioBrief } = this.state;
    let kycDetails =
      this.state.campaign && this.state.campaign.kycDetails.length > 0
        ? this.state.campaign.kycDetails[0]
        : null;
    let userDetails =
      this.state.campaign && this.state.campaign.userDetails.length > 0
        ? this.state.campaign.userDetails[0]
        : null;
    let touser = this.state.campaign.uploadedby
      ? this.state.campaign.uploadedby
      : userDetails.email;
    if (this.state.campaign.sallerId) {
      touser = touser + "," + this.state.campaign.sallerId;
    }
    return (
      <div className="main_wrapper view_detail">
        <ApproveModel
          isShowing={isShowing}
          hide={this.toggle}
          user_email={touser}
          changedby={userDetails.email}
          campaignId={this.state.campaign._id}
          custommsg={this.state.custommsg}
          station={this.state.campaign.station}
        />{" "}
        <RejectModel
          isRejectShowing={isRejectShowing}
          hide={this.rejectToggle}
          user_email={touser}
          changedby={userDetails.email}
          campaignId={this.state.campaign._id}
          station={this.state.campaign.station}
        />{" "}
        {this.state.toggleAudioBrief && (
          <AudioBriefPopup
            hideAudioBrief={this.showHideAudioBrief}
            campaignDetails={campaign}
            type="update"
            audioBrief={this.state.audioBrief}
          />
        )}{" "}
        <UserSideMenu {...props} />{" "}
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                <div className="container-head print_head">
                  <div className="campdashboard-breadcrumb">
                    Campaign Management &{" "}
                    <span className="campdeatil_head"> Campaign Detail </span>{" "}
                  </div>{" "}
                  {this.state.campaign.contract_file_url && (
                    <div className="gstdetail">
                      <div className="download_gst">
                        {" "}
                        {this.state.campaign.contract_file_url && (
                          <div className="downloadaudio_file gst_file">
                            <a
                              href={
                                this.state.campaign.contract_file_url
                                  ? `${this.state.campaign.contract_file_url}`
                                  : ""
                              }
                              download
                              target="__blank"
                            >
                              Download Contract{" "}
                            </a>{" "}
                          </div>
                        )}{" "}
                      </div>{" "}
                    </div>
                  )}{" "}
                  <div className="print_btn">
                    <button onClick={this.generatePdf}>
                      {" "}
                      Download Campaign Details{" "}
                    </button>{" "}
                  </div>{" "}
                </div>
                <div className="campviewlist_detail_wrapper">
                  <div className="campviewlist_detail_left">
                    <h2 className="campview-detail_header">
                      {" "}
                      Campaign Detail{" "}
                    </h2>{" "}
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          {" "}
                          Campaign Name{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.name}{" "}
                        </span>{" "}
                      </div>{" "}
                      <div className="campviewlist_data">
                        <span className="campviewlist_head"> Brand Name </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.brand}{" "}
                        </span>{" "}
                      </div>{" "}
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          {" "}
                          Product Category{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.product}{" "}
                        </span>{" "}
                      </div>{" "}
                    </div>{" "}
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          {" "}
                          Package Type{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.type}{" "}
                        </span>{" "}
                      </div>{" "}
                      <div className="campviewlist_data">
                        <span className="campviewlist_head"> Days Count </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.days}{" "}
                        </span>{" "}
                      </div>{" "}
                      <div className="campviewlist_data">
                        <span className="campviewlist_head"> Start Date </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {moment(this.state.campaign.startDate).format(
                            "DD/MM/YYYY"
                          )}{" "}
                        </span>{" "}
                      </div>{" "}
                    </div>{" "}
                    <div className="campviewlist_left_inner">
                      {" "}
                      {this.state.campaign.rotationPerDay && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            {" "}
                            Rotation Per Day{" "}
                          </span>{" "}
                          <span className="campviewlist_name">
                            {" "}
                            {this.state.campaign.rotationPerDay}{" "}
                          </span>{" "}
                        </div>
                      )}{" "}
                      {!this.state.campaign.rotationPerDay && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head"> </span>{" "}
                          <span className="campviewlist_name"> </span>{" "}
                        </div>
                      )}{" "}
                      {this.state.campaign.audioLength && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            {" "}
                            Audio length{" "}
                          </span>{" "}
                          <span className="campviewlist_name">
                            {" "}
                            {this.state.campaign.audioLength}{" "}
                          </span>{" "}
                        </div>
                      )}{" "}
                      {!this.state.campaign.audioLength && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head"> </span>{" "}
                          <span className="campviewlist_name"> </span>{" "}
                        </div>
                      )}{" "}
                      {this.state.campaign.bigFmAudio &&
                        this.state.campaign.bigFmAudio === "false" && (
                          <div className="campviewlist_data">
                            <span className="campviewlist_head">
                              {" "}
                              Audio Duration{" "}
                            </span>{" "}
                            <span className="campviewlist_name">
                              {" "}
                              {this.state.campaign.audioDuration &&
                                this.state.campaign.audioDuration.toFixed(
                                  0
                                )}{" "}
                            </span>{" "}
                          </div>
                        )}{" "}
                      {this.state.campaign.bigFmAudio &&
                        this.state.campaign.bigFmAudio === "true" && (
                          <div className="campviewlist_data">
                            <span className="campviewlist_head"> </span>{" "}
                            <span className="campviewlist_name"> </span>{" "}
                          </div>
                        )}{" "}
                    </div>{" "}
                    <div className="campviewlist_left_inner">
                      {this.state.campaign.bookingType && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">Time Band </span>{" "}
                          <span
                            className="campviewlist_name"
                            style={{ textTransform: "capitalize" }}
                          >
                            {this.state.campaign.bookingType}{" "}
                          </span>{" "}
                        </div>
                      )}
                      {this.state.campaign.timebands && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            Selected Bands{" "}
                          </span>{" "}
                          <span className="campviewlist_name">
                            {this.state.campaign.timebands}{" "}
                          </span>{" "}
                        </div>
                      )}
                      {this.state.campaign.language && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            Audio Language
                          </span>{" "}
                          <span className="campviewlist_name">
                            {this.state.campaign.language}{" "}
                          </span>{" "}
                        </div>
                      )}
                    </div>
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          What is the objective of your campaign ?
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.objective}{" "}
                        </span>{" "}
                      </div>{" "}
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          {" "}
                          Audio Uploaded By{" "}
                        </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.bigFmAudio
                            ? "User"
                            : "BigFM"}{" "}
                        </span>{" "}
                      </div>{" "}
                      <div className="campviewlist_data">
                        <span className="campviewlist_head"> Campaign ID </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign._id}{" "}
                        </span>{" "}
                      </div>{" "}
                    </div>{" "}
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head"> Station </span>{" "}
                        <span className="campviewlist_name">
                          {" "}
                          {this.state.campaign.station.includes(",") ? (
                            <a
                              onClick={(e) => {
                                this.setState({
                                  showstationlist: true,
                                  currentStations: this.state.campaign.station.split(
                                    ","
                                  ),
                                });
                              }}
                            >
                              Multiple (
                              {this.state.campaign.station.split(",").length})
                            </a>
                          ) : (
                            this.state.campaign.station
                          )}
                        </span>{" "}
                      </div>{" "}
                      {this.state.campaign.sallerId && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            {" "}
                            Sales Representative ID{" "}
                          </span>{" "}
                          <span className="campviewlist_name">
                            {" "}
                            {this.state.campaign.sallerId}{" "}
                          </span>{" "}
                        </div>
                      )}
                    </div>
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          Audio Brief{" "}
                          {this.state.campaign.bigFmAudio &&
                            this.state.campaign.bigFmAudio === "true" &&
                            (this.state.campaign.audioStatus === "Requested" ||
                              this.state.campaign.audioStatus ===
                                "Audio Rejected") && (
                              <a onClick={this.showHideAudioBrief}>
                                <img
                                  className="img_icon"
                                  src="/assets/images/edit.png"
                                />
                              </a>
                            )}
                        </span>{" "}
                        {/* <span className="campviewlist_name">{this.state.campaign.audioBrief}</span> */}{" "}
                      </div>{" "}
                    </div>
                    {this.state.campaign.bigFmAudio &&
                      this.state.campaign.bigFmAudio === "true" && (
                        <div className="audio_brief">
                          <div
                            style={this.styles.editor}
                            onClick={this.focusEditor}
                          >
                            <Editor
                              ref={this.setEditorState}
                              readOnly={this.state.editoreditstate}
                              placeholder="Enter Audio Brief"
                              editorState={this.state.audioBrief}
                              onChange={this.getAudioBrief}
                            />{" "}
                          </div>{" "}
                        </div>
                      )}
                    {this.state.campaign.fileName &&
                      this.state.campaign.audioUrls &&
                      this.state.campaign.audioUrls.length == 0 && (
                        <div className="campviewlist_left_inner">
                          <div className="campviewlist_data">
                            <span className="campviewlist_head">
                              {" "}
                              Uploaded Audio File{" "}
                            </span>{" "}
                            <div className="campviewlist_name">
                              <div className="audio_inner">
                                <div className="viewaudio_img">
                                  <img src="../../../assets/images/song.svg" />
                                </div>{" "}
                                <div className="file_desc">
                                  <div className="file_name_size">
                                    <div className="file_name">
                                      {" "}
                                      {audioFile
                                        ? audioFile[0].name
                                        : this.state.campaign.fileName}{" "}
                                    </div>{" "}
                                    <span className="file_size">
                                      Audio length :{" "}
                                      {this.state.filesFields.audioDuration
                                        ? Math.round(
                                            this.state.filesFields.audioDuration
                                          )
                                        : props.campaign.audioDuration.toFixed(
                                            0
                                          )}{" "}
                                      sec
                                    </span>
                                  </div>{" "}
                                  <div className="filesize_download">
                                    <span>
                                      {" "}
                                      {audioFile && audioFile[0].size
                                        ? audioFile[0].size
                                        : this.audioRoundOff(
                                            this.state.campaign.fileSize
                                          )}{" "}
                                    </span>{" "}
                                    {this.state.campaign.status ===
                                      "Audio Rejected" &&
                                    this.state.campaign.bigFmAudio ===
                                      "false" ? (
                                      <div className="upload-btn-wrapper">
                                        <button className="btn">
                                          {" "}
                                          CHANGE{" "}
                                        </button>{" "}
                                        <input
                                          type="file"
                                          name="audioFile"
                                          onChange={this.handleUpload}
                                          accept="audio/mp3,audio/wave"
                                        />
                                      </div>
                                    ) : (
                                      <div className="downloadaudio_file">
                                        {" "}
                                        {/* <a href= {`${fileUrl}/${this.state.campaign.audioUrl}`}
                                                                        target= "__blank" download>Download</a> */}{" "}
                                      </div>
                                    )}{" "}
                                  </div>{" "}
                                </div>{" "}
                              </div>{" "}
                            </div>{" "}
                          </div>{" "}
                          <div className="campviewlist_data">
                            <div className="campviewlist_left_audio_player">
                              {!this.state.filesFields.audioDuration && (
                                <ReactAudioPlayer
                                  src={props.campaign.audioUrl}
                                  controls
                                  controlsList="nodownload"
                                />
                              )}
                            </div>{" "}
                            <div>
                              {" "}
                              {this.state.campaign.bigFmAudio &&
                                this.state.campaign.bigFmAudio === "true" &&
                                this.state.campaign.audioStatus ===
                                  "Uploaded" && (
                                  <div className="filesize_download">
                                    <span> </span>{" "}
                                    <div className="downloadaudio_file">
                                      <a onClick={this.toggle}> Accept </a>{" "}
                                      <a
                                        style={{
                                          marginLeft: "10px",
                                        }}
                                        onClick={this.rejectToggle}
                                      >
                                        Reject{" "}
                                      </a>{" "}
                                    </div>{" "}
                                  </div>
                                )}{" "}
                            </div>{" "}
                          </div>{" "}
                        </div>
                      )}
                    {this.state.campaign.audioUrls &&
                      this.state.campaign.audioUrls.length > 0 && (
                        <div className="campviewlist_left_inner">
                          <div className="campviewlist_head">
                            Uploaded Audio Files
                          </div>
                        </div>
                      )}
                    {this.state.campaign.audioUrls &&
                      this.state.campaign.audioUrls.length > 0 &&
                      this.state.campaign.audioUrls.map((audio) => {
                        return (
                          <React.Fragment>
                            <div className="campviewlist_left_inner">
                              <div className="campviewlist_data">
                                <div className="campviewlist_name">
                                  <div className="audio_inner">
                                    <div className="viewaudio_img">
                                      <img src="../../../assets/images/song.svg" />
                                    </div>{" "}
                                    <div className="file_desc">
                                      <div className="file_name_size">
                                        <div className="file_name">
                                          {" "}
                                          {audio
                                            ? audio.name
                                            : this.state.campaign.fileName}{" "}
                                        </div>{" "}
                                        <span className="file_size">
                                          Audio length :{" "}
                                          {this.state.filesFields.audioDuration
                                            ? Math.round(
                                                this.state.filesFields
                                                  .audioDuration
                                              )
                                            : props.campaign.audioDuration.toFixed(
                                                0
                                              )}{" "}
                                          sec
                                        </span>
                                      </div>{" "}
                                      <div className="filesize_download">
                                        <span>
                                          {" "}
                                          {audioFile && audioFile[0].size
                                            ? audioFile[0].size
                                            : this.audioRoundOff(
                                                this.state.campaign.fileSize
                                              )}{" "}
                                        </span>{" "}
                                      </div>{" "}
                                    </div>{" "}
                                  </div>{" "}
                                </div>{" "}
                              </div>{" "}
                              <div className="campviewlist_data">
                                <div className="campviewlist_left_audio_player">
                                  <ReactAudioPlayer
                                    src={audio.awsurl}
                                    controls
                                    controlsList="nodownload"
                                  />
                                </div>{" "}
                                <div> </div>{" "}
                              </div>{" "}
                            </div>
                          </React.Fragment>
                        );
                      })}
                    {this.state.campaign.audiourls &&
                    this.state.campaign.audioUrls.length > 0 &&
                    this.state.campaign.status === "Audio Rejected" &&
                    this.state.campaign.bigFmAudio === "false" &&
                    this.state.audioFiles.length == 0 ? (
                      <div
                        className="upload-btn-wrapper"
                        style={{ marginBottom: "15px" }}
                      >
                        <span style={{ marginBottom: "10px" }}>
                          Select files to Replace the Audios
                        </span>
                        <Drag getUploadedFile={this.getUploadedFile} />
                      </div>
                    ) : (
                      <div className="downloadaudio_file">
                        {" "}
                        {/* <a href= {`${fileUrl}/${this.state.campaign.audioUrl}`}
                                                                        target= "__blank" download>Download</a> */}{" "}
                      </div>
                    )}
                    {this.state.audioFiles.length > 0 &&
                      this.state.audioFiles.map((audio) => {
                        return (
                          <div className="upload_file">
                            Selected Files to Replace Audios
                            <div>
                              <div className="audio_img">
                                {" "}
                                <img src="../../assets/images/song.svg" />
                              </div>
                              <div className="file_desc">
                                <div className="file_name_size">
                                  <div className="file_name">{audio.path}</div>
                                </div>
                                <div className="remove_file">
                                  <a
                                    onClick={() => {
                                      this.removeFileInCollection(audio.path);
                                    }}
                                  >
                                    {" "}
                                    REMOVE
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    {this.state.campaign.audioUrls &&
                      this.state.campaign.audioUrls.length > 0 &&
                      this.state.campaign.bigFmAudio &&
                      this.state.campaign.bigFmAudio === "true" &&
                      this.state.campaign.audioStatus === "Uploaded" && (
                        <div
                          className="filesize_download"
                          style={{ marginBottom: "15px" }}
                        >
                          <span> </span>{" "}
                          <div className="downloadaudio_file">
                            <a onClick={this.toggle}> Accept </a>
                            <a
                              style={{
                                marginLeft: "10px",
                              }}
                              onClick={this.rejectToggle}
                            >
                              Reject{" "}
                            </a>{" "}
                          </div>{" "}
                        </div>
                      )}{" "}
                    {this.state.campaign.history &&
                      this.state.campaign.history.length > 0 && (
                        <div className="campviewlist_left_inner">
                          <table className="table table-striped master-table">
                            <thead>
                              <tr>
                                <th> File Name </th>
                                <th> Status </th>
                                <th> Reason </th>
                                {this.state.campaign.bigFmAudio &&
                                  this.state.campaign.bigFmAudio === "true" && (
                                    <th> Audio Brief </th>
                                  )}{" "}
                                <th> Status Changed By </th>
                              </tr>{" "}
                            </thead>{" "}
                            <tbody>
                              {this.state.campaign.history.map((c, i) => (
                                <tr key={i}>
                                  <td> {c.fileName} </td>{" "}
                                  <td> {c.audioStatus} </td>{" "}
                                  <td> {c.reason} </td>{" "}
                                  {this.state.campaign.bigFmAudio &&
                                    this.state.campaign.bigFmAudio ===
                                      "true" && (
                                      <td className="txt-cntr">
                                        <a>
                                          <span className="tooltip-reject view-tooltip">
                                            {" "}
                                            {/*<img src="/assets/images/upload.png" className="upload-png reject-png" onClick={() => history.push('/admin/audioadminmanagment/UploadAudiolist',{a})}>*/}{" "}
                                            <img
                                              src="/assets/images/eye.png"
                                              className="img_icon"
                                              onClick={this.showHideAudioBrief}
                                            ></img>{" "}
                                            <span> View </span>{" "}
                                          </span>{" "}
                                        </a>{" "}
                                      </td>
                                    )}{" "}
                                  <td>{c.audiostatuschangedby}</td>
                                </tr>
                              ))}{" "}
                            </tbody>{" "}
                          </table>
                        </div>
                      )}
                  </div>
                  <div className="campviewlist_detail_right">
                    <div className="campviewlist_cost_card">
                      <h5> Campaign Cost </h5>{" "}
                      <ul className="campviewlist_cost_list">
                        {this.state.campaign.packageCost &&
                          this.state.campaign.packageCost !==
                            this.state.campaign.actualpackageCost && (
                            <li className="campviewlist_list_inner">
                              <div className="campviewlist_type">
                                {" "}
                                Actual Package Cost{" "}
                              </div>{" "}
                              <div className="campviewlist_rupee_symb">
                                <img src="../../assets/images/rupee-indian.svg" />
                                <span className="cost_inner">
                                  {" "}
                                  {this.state.campaign.actualpackageCost}{" "}
                                </span>{" "}
                              </div>{" "}
                            </li>
                          )}
                        {this.state.campaign.couponDiscount > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type coupon">
                              Coupon Discount{" "}
                              {this.state.campaign.couponPercentage > 0 && (
                                <span className="discount_desc">
                                  Coupon Applied Flat ${" "}
                                  {this.state.campaign.couponPercentage} % OFF{" "}
                                </span>
                              )}{" "}
                            </div>{" "}
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {" "}
                                {this.state.campaign.couponDiscount}{" "}
                              </span>{" "}
                            </div>{" "}
                          </li>
                        )}{" "}
                        {this.state.campaign.packageCost > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type">
                              {" "}
                              Package Cost{" "}
                            </div>{" "}
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {" "}
                                {this.state.campaign.packageCost}{" "}
                              </span>{" "}
                            </div>{" "}
                          </li>
                        )}
                        {this.state.campaign.packageTax > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type">
                              {" "}
                              Package Tax @18 %{" "}
                            </div>{" "}
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {" "}
                                {this.state.campaign.packageTax}{" "}
                              </span>{" "}
                            </div>{" "}
                          </li>
                        )}
                        {this.state.campaign.audioCost > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type">
                              {" "}
                              Audio Cost{" "}
                            </div>{" "}
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {" "}
                                {this.state.campaign.audioCost}{" "}
                              </span>{" "}
                            </div>{" "}
                          </li>
                        )}{" "}
                        {this.state.campaign.audioTax > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type">
                              {" "}
                              Audio Tax @18%{" "}
                            </div>{" "}
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {" "}
                                {this.state.campaign.audioTax}{" "}
                              </span>{" "}
                            </div>{" "}
                          </li>
                        )}{" "}
                        {(this.state.campaign.nonFCTCodeAmount &&
                          this.state.campaign.nonFCTCodeAmount > 0) ? (
                            <li className="campviewlist_list_inner">
                              <div className="campviewlist_type">
                                {" "}
                                Non FCT Amount{" "}
                              </div>{" "}
                              <div className="campviewlist_rupee_symb">
                                <img src="../../assets/images/rupee-indian.svg" />
                                <span className="cost_inner">
                                  {" "}
                                  {this.state.campaign.nonFCTCodeAmount}{" "}
                                </span>{" "}
                              </div>{" "}
                            </li>
                          ): ''}{" "}
                        {this.state.campaign.nonFCTCodeAmountTax &&
                          this.state.campaign.nonFCTCodeAmountTax > 0 && (
                            <li className="campviewlist_list_inner">
                              <div className="campviewlist_type">
                                {" "}
                                Non FCT Tax @18%{" "}
                              </div>{" "}
                              <div className="campviewlist_rupee_symb">
                                <img src="../../assets/images/rupee-indian.svg" />
                                <span className="cost_inner">
                                  {" "}
                                  {this.state.campaign.nonFCTCodeAmountTax}{" "}
                                </span>{" "}
                              </div>{" "}
                            </li>
                          )}{" "}
                        <div className="totalcost">
                          <div className="campviewlist_type"> Total Cost </div>{" "}
                          <div className="campviewlist_rupee_symb">
                            <img src="../../assets/images/rupee-indian_white.svg" />{" "}
                            <span className="cost_inner">
                              {" "}
                              {this.state.campaign.totalCost}{" "}
                            </span>{" "}
                          </div>{" "}
                        </div>{" "}
                      </ul>
                      <div>
                        {" "}
                        {this.state.campaign.audioRefundAmount > 0 && (
                          <React.Fragment>
                            <ul className="camp_cost_list">
                              <h5 className="camp_pay_now"> Audio Refund </h5>{" "}
                              <li className="cost_list_inner">
                                <div className="cost_type"> Audio cost </div>{" "}
                                <div className="rupee_symb">
                                  <img src="../../assets/images/rupee-indian.svg" />
                                  <span className="cost_inner">
                                    {" "}
                                    {this.state.campaign.audioCost}{" "}
                                  </span>{" "}
                                </div>{" "}
                              </li>{" "}
                              <li className="cost_list_inner">
                                <div className="cost_type"> Audio Tax </div>{" "}
                                <div className="rupee_symb">
                                  <img src="../../assets/images/rupee-indian.svg" />
                                  <span className="cost_inner">
                                    {" "}
                                    {this.state.campaign.audioTax}{" "}
                                  </span>{" "}
                                </div>{" "}
                              </li>{" "}
                            </ul>
                            <div className="totalcost">
                              <div className="campviewlist_type">
                                {" "}
                                Gross Total{" "}
                              </div>{" "}
                              <div className="campviewlist_rupee_symb">
                                <img src="../../assets/images/rupee-indian_white.svg" />{" "}
                                {!this.state.campaign.audioRefundAmount && (
                                  <span className="cost_inner">
                                    {" "}
                                    {this.state.campaign.totalCost}{" "}
                                  </span>
                                )}{" "}
                                {this.state.campaign.audioRefundAmount && (
                                  <span className="cost_inner">
                                    {" "}
                                    {this.state.campaign.totalCost -
                                      this.state.campaign
                                        .audioRefundAmount}{" "}
                                  </span>
                                )}{" "}
                              </div>{" "}
                            </div>{" "}
                          </React.Fragment>
                        )}
                        {this.state.campaign.payId &&
                          this.state.campaign.audioCost > 0 &&
                          this.state.campaign.pendingAmount > 0 && (
                            <ul className="camp_cost_list">
                              <h5 className="camp_pay_now"> Amount Paid </h5>{" "}
                              <li className="cost_list_inner">
                                <div className="cost_type">
                                  {" "}
                                  Audio cost + Taxes{" "}
                                </div>{" "}
                                <div className="rupee_symb">
                                  <img src="../../assets/images/rupee-indian.svg" />
                                  <span className="cost_inner">
                                    {" "}
                                    {this.state.campaign.audioTotal}
                                  </span>{" "}
                                </div>{" "}
                              </li>{" "}
                            </ul>
                          )}{" "}
                        {this.state.campaign.payId &&
                          this.state.campaign.audioCost > 0 &&
                          campaign.pendingAmount > 0 && (
                            <ul className="camp_cost_list">
                              <h5 className="camp_pay_now">
                                {" "}
                                Amount to be Paid{" "}
                              </h5>{" "}
                              <li className="cost_list_inner">
                                <div className="cost_type">
                                  {" "}
                                  Package + Taxes{" "}
                                </div>{" "}
                                <div className="rupee_symb">
                                  <img src="../../assets/images/rupee-indian.svg" />{" "}
                                  {/* {{this.state.campaign.totalPackageCost -
                                                                  this.state.campaign.packageDiscountedCost} >=30000 ||{this.state.campaign.}} */}{" "}
                                  <span className="cost_inner">
                                    {" "}
                                    {this.state.campaign.packageTotal}{" "}
                                  </span>{" "}
                                </div>{" "}
                              </li>{" "}
                              {this.state.campaign.nonFCTCodeAmountTotal &&
                                this.state.campaign.nonFCTCodeAmountTotal >
                                  0 && (
                                  <li className="cost_list_inner">
                                    <div className="cost_type">
                                      {" "}
                                      Non FCT + Taxes{" "}
                                    </div>{" "}
                                    <div className="rupee_symb">
                                      <img src="../../assets/images/rupee-indian.svg" />{" "}
                                      {/* {{this.state.campaign.totalPackageCost -
                                                                  this.state.campaign.packageDiscountedCost} >=30000 ||{this.state.campaign.}} */}{" "}
                                      <span className="cost_inner">
                                        {" "}
                                        {
                                          this.state.campaign
                                            .nonFCTCodeAmountTotal
                                        }{" "}
                                      </span>{" "}
                                    </div>{" "}
                                  </li>
                                )}
                              {this.state.campaign.nonFCTCodeAmountTotal &&
                                this.state.campaign.nonFCTCodeAmountTotal >
                                  0 && (
                                  <li className="cost_list_inner">
                                    <div className="cost_type">
                                      {" "}
                                      Total Amount{" "}
                                    </div>{" "}
                                    <div className="rupee_symb">
                                      <img src="../../assets/images/rupee-indian.svg" />{" "}
                                      {/* {{this.state.campaign.totalPackageCost -
                                                                  this.state.campaign.packageDiscountedCost} >=30000 ||{this.state.campaign.}} */}{" "}
                                      <span className="cost_inner">
                                        {" "}
                                        {this.state.campaign
                                          .nonFCTCodeAmountTotal +
                                          this.state.campaign.packageTotal}{" "}
                                      </span>{" "}
                                    </div>{" "}
                                  </li>
                                )}
                              {this.state.audioDiscountStatus && (
                                <li className="cost_list_inner">
                                  <div className="cost_type">
                                    Rebate of Audio Cost and its taxes amounting
                                    to {this.state.campaign.audioTotal}
                                    is applicable if the balance is paid before{" "}
                                    {this.state.paymentCutOffTime}
                                    {/* Audio Cost and its taxes will be rebated if
                                    the balance payment is done before{" "}
                                    {this.state.paymentCutOffTime} */}
                                  </div>{" "}
                                </li>
                              )}{" "}
                            </ul>
                          )}{" "}
                      </div>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>
                <div className="detail_wrapper">
                  <div className="package_wrapper">
                    <div className="package_includes_wrapper">
                      {this.state.campaign.crossRefId && (
                        <div>
                          <h3> Associate Campaign Id</h3>
                          <p>
                            <a
                              id={this.state.campaign.crossRefId}
                              onClick={this.HandleCrossRef}
                            >
                              {this.state.campaign.crossRefId}
                            </a>
                          </p>
                        </div>
                      )}
                      {this.state.campaign.fctperDay > 0 &&
                        this.state.campaign.secondages > 0 &&
                        this.state.campaign.additionalBenefits &&
                        this.state.campaign.packageDiscountedCost > 0 && (
                          <div>
                            <h3> Package Includes: </h3>{" "}
                            <p>
                              {" "}
                              {this.state.campaign.fctperDay}
                              Seconds Per Day I {this.state.campaign.secondages}
                              Total Secondages I Total Cost:{" "}
                              {this.state.campaign.totalCost}
                              INR I Additional Benefit:{" "}
                              {this.state.campaign.additionalBenefits} % I
                              Discounted Cost:{" "}
                              {this.state.campaign.packageDiscountedCost}
                              INR{" "}
                            </p>{" "}
                            {this.state.campaign.nonFCT &&
                              this.state.campaign.nonFCT[0] && (
                                <div>
                                  <br />
                                  <h3> NON FCT Addons: </h3>{" "}
                                  <p>
                                    {this.state.campaign.nonFCT[0].description}
                                  </p>
                                </div>
                              )}
                          </div>
                        )}{" "}
                      {this.state.campaign.secondages > 0 &&
                        this.state.campaign.additionalBenefits > 0 &&
                        this.state.campaign.packageDiscountedCost > 0 && (
                          <div>
                            <h3> Package Includes: </h3>{" "}
                            <p>
                              {" "}
                              {this.state.campaign.secondages}
                              Total Secondages I Total Cost:{" "}
                              {this.state.campaign.totalCost}
                              INR I Additional Benefit:{" "}
                              {this.state.campaign.additionalBenefits} % I
                              Discounted{" "}
                              {(this.state.campaign.type === "Weekly" ||
                                this.state.campaign.type === "Weekend") && (
                                <span> Worth </span>
                              )}{" "}
                              {(this.state.campaign.type === "Day Based" ||
                                this.state.campaign.type ===
                                  "Frequency Based" ||
                                this.state.campaign.type ===
                                  "Rotation Based") && <span> Cost </span>}
                              : {this.state.campaign.packageDiscountedCost}
                              INR
                            </p>{" "}
                            {this.state.campaign.nonFCT &&
                              this.state.campaign.nonFCT[0] && (
                                <div>
                                  <br />
                                  <h3> NON FCT Addons: </h3>{" "}
                                  <p>
                                    {this.state.campaign.nonFCT[0].description}
                                  </p>
                                </div>
                              )}
                          </div>
                        )}{" "}
                    </div>{" "}
                    {this.state.campaign.status == "Audio Rejected" &&
                    this.state.campaign.bigFmAudio == "false" ? (
                      <div className="view-btn_wrapper">
                        <button
                          className="viewdetail_back"
                          onClick={this.updateCampaign}
                        >
                          PROCEED{" "}
                        </button>{" "}
                      </div>
                    ) : (
                      <div className="view-btn_wrapper">
                        <button
                          className="viewdetail_back"
                          onClick={() => {
                            history.replace("/dashboard", {
                              updatedCampaign: "",
                            });
                            props.handleBack();
                          }}
                        >
                          BACK{" "}
                        </button>{" "}
                      </div>
                    )}{" "}
                    {this.state.campaign.pendingAmount > 0 &&
                      (this.state.campaign.status === "Audio Approved" ||
                        this.state.campaign.status === "On-Hold") && (
                        <div className="view-btn_wrapper">
                          <button
                            className="viewdetail_back"
                            onClick={this.checkTransactionTime}
                          >
                            PAY{" "}
                          </button>{" "}
                        </div>
                      )}{" "}
                    {!this.state.campaign.payId &&
                      this.state.campaign.paymentDetails.length === 0 && (
                        <div className="view-btn_wrapper">
                          <button
                            className="viewdetail_back"
                            onClick={this.checkTransactionTime}
                          >
                            PAY{" "}
                          </button>{" "}
                        </div>
                      )}{" "}
                  </div>{" "}
                  {!this.state.showPaymentModel && <ToastContainer />}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
        {<GetPdfHtml campaign={campaign} />}{" "}
        <PaymentModel
          isShowing={this.state.showPaymentModel}
          hide={this.hidePaymentModel}
          makePayment={this.makePayment}
          submitTransactionDetails={this.submitTransactionDetails}
          savedraft={this.state.savedraft}
          payamount={
            !this.state.campaign.payId &&
            this.state.campaign.bigFmAudio == "false"
              ? Number(this.state.campaign.totalCost)
              : !this.state.campaign.payId &&
                this.state.campaign.bigFmAudio == "true"
              ? Number(
                  this.state.campaign.audioCost +
                    Math.floor(this.state.campaign.audioCost * 0.18)
                )
              : Number(this.state.campaign.pendingAmount)
          }
        />
        {this.state.changeStartDate && (
          <ChangeStartDate
            okButtonShow={true}
            closeAction={this.startDateHandler}
            okButtonText="Proceed to Payment"
            okAction={this.hidePaymentModel}
            cancelButtonShow={true}
            cancelButtonText="Cancel"
            minStartDate={this.state.minStartDate}
            handleDate={this.handleStartDate}
            startDate={this.state.startDate}
            msg="Please Select a New Start Date to Proceed the Campaign"
          />
        )}
        {this.state.showstationlist && (
          <ShowStations
            stations={this.state.currentStations}
            closeAction={this.hideshowstations}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateCompainAudio: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
    showError: (error) => {
      dispatch({
        type: ANY_ERROR,
        payload: error,
      });
    },
  };
};

export default connect(null, mapDispatchToProps)(ViewCampaign);



// WEBPACK FOOTER //
// ./web/components/campaign/viewcampaign.js